import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AppReleaseActivity extends Component {
    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Saas/AppRelease/AppReleaseBrowser")
    }

    render() {
        return (
            <Activity 
                name="AppRelease"
                RenderedComponent={this.RenderedComponent}
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AppReleaseActivity)
